import { useAppDispatch } from "../../../app/hooks";
import { classroomSlice } from "../../../redux/classroom/classroomSlice";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";
import { hasPermission, PermissionId } from "../../../app/permissions";
import AddIcon from "@mui/icons-material/Add";
import PrizaAvatarGrid, { PrizaAvatarGridItem } from "../../../features/base/grid/PrizaAvatarGrid";
import { assertThumbnailUrl, LoadState } from "../../../redux/common";
import { retrieveSubjectList, selectSubjectList, subjectListSlice } from "../../../redux/curriculum/subjectListSlice";
import { useEffect, useState } from "react";
import { isTokenReady } from "../../../features/user/UserAvatar";
import { subjectSlice } from "../../../redux/curriculum/subjectSlice";
import { SubjectInsUpd } from "../../curriculum/ins-upd/subject/SubjectInsUpd";
import { SubjectInfo } from "../../../redux/curriculum/model";

interface ContentListProps {
    schoolId: string;
}

const SubjectList = ({ schoolId }: ContentListProps) => {
    const dispatch = useAppDispatch();
    const user = useSelector(selectUser);
    const subjects = useSelector(selectSubjectList);

    const [changing, setChanging] = useState(false);
    const [selectedSubject, setSelectedSubject] = useState(undefined as SubjectInfo | undefined);

    useEffect(() => {
        if (subjects.schoolId && subjects.schoolId != schoolId) {
            dispatch(subjectListSlice.actions.clean());
        }
        if (subjects.state.state == LoadState.NotStarted && isTokenReady(user))
            dispatch(retrieveSubjectList({ schoolId }));
    }, [subjects, schoolId, user]);

    if (changing) {
        return <SubjectInsUpd
            back={() => {
                setSelectedSubject(undefined);
                setChanging(false);
            }}
            schoolId={schoolId}
            subject={selectedSubject} />;
    }

    const list = subjects.list || [];

    const mapped: PrizaAvatarGridItem[] = list.map((item) => {
        return {
            image: assertThumbnailUrl(item.url),
            title: item.name,
            subtitle: "Disciplina",
            click: () => {
                setSelectedSubject(item);
                setChanging(true);
            }
        };
    });

    const buttons = hasPermission(user.priza.info, PermissionId.SCHOOL_ADMIN, schoolId) ? [
        {
            label: <AddIcon />,
            click: () => {
                setSelectedSubject(undefined);
                setChanging(true);
            }
        }
    ] : undefined;

    return <PrizaAvatarGrid list={mapped}
        toolbar={{
            label: "Disciplinas",
            buttons: buttons
        }}
        state={subjects.state}
        retry={() => { dispatch(subjectListSlice.actions.clean()); }}
        messages={{
            empty: "Nenhuma disciplina associada a esta escola.",
            error: "Erro ao carregar disciplinas."
        }}
    />;

};

export default SubjectList;
